// extracted by mini-css-extract-plugin
module.exports = {"FormItem":"Input_FormItem__12YJp"};